/**
 * 삼성(019) 오더목록 페이지 ($j.Pages.Partner.SamsungOrderList / body data-page-name="SamsungOrderList")
 *
 * 레거시 public/scs/main.php 대체.
 *
 * 주소는 범용 화면과 같은 /p/orders 이고, 서버(Partner\OrderController)가 세션 소속으로 이 화면을 고른다.
 * 범용 화면과 달리 DataTables 를 쓰지 않는다 — 월 단위 전량 렌더 + 하단 VAT 합계 +
 * 엑셀 제출이 한 묶음인 정산용 화면이라 페이징이 들어가면 그 워크플로우가 깨진다.
 * 검색은 GET 파라미터 + 페이지 리로드(레거시와 동일).
 *
 * 오더 확인체크/메모는 public/js/scs.js 의 전역(orderStatusSet / setOrderStatusSetTo)이 담당한다.
 */
import Form from '../../Common/Form';

export default class SamsungOrderList {
    constructor() {
        this.openedOrder = 0;   // 현재 펼쳐진 행의 오더번호 (0 = 없음)
        this.shownPhoto  = 0;   // 사진 팝업이 열려있는 오더번호
        this.atBottom    = false;
    }

    initialize() {
        // ─── 서버 계산값 (컨트롤러 $pageData → #page-data) ───
        const el = document.getElementById('page-data');
        const d = el ? JSON.parse(el.textContent) : {};
        this.sosok            = d.sosok || '';
        this.loginType        = d.loginType || '';
        this.showGisaSelect   = !!d.showGisaSelect;
        this.showCenterSelect = !!d.showCenterSelect;

        this.initActions();
        this.exposeGlobals();
        this.initSelects();
        this.initDatePicker();
        this.initScrollArrow();
        this.initKeyHandler();
    }

    /**
     * 화면의 버튼·칸 — data-sl="동작" (값은 data-n 등). window 에 함수를 내놓지 않는다.
     * 검색칸은 엔터=검색 (.js-skw), 셀렉트·검색월은 data-sl-change.
     */
    initActions() {
        const CLICK = {
            serRangeset:     (el) => this.serRangeset(Number(el.dataset.n)),
            selchtype:       (el) => this.selchtype(el),
            selchUnreviewed: (el) => this.selchUnreviewed(el),
            reserch:         () => this.reserch(),
            newOrder:        () => this.newOrder(),
            saveToExcel:     () => this.saveToExcel(),
            showOrderPhoto:  (el) => this.showOrderPhoto(el, Number(el.dataset.n)),
            noPhoto:         () => alert('등록된 사진이 없습니다.'),
            toggleDetail:    (el) => this.toggleDetail(Number(el.dataset.n)),
            showMap:         (el) => this.showMap(el.dataset.gps1, el.dataset.gps2),
            // 확인체크·메모 모달은 public/js/scs.js 의 전역이 그린다
            orderStatus:     (el) => window.orderStatusSet(el, Number(el.dataset.n), Number(el.dataset.rev)),
            hidePhotoList:   () => $('#photoListshow').hide(),
            showPic:         (el) => this.showPic(Number(el.dataset.o), Number(el.dataset.n)),   // 사진 썸네일(_photoThumbs)
        };
        $(document).on('click.samsungList', '[data-sl]', function (e) {
            const fn = CLICK[this.dataset.sl];
            if (!fn) return;
            if (this.tagName === 'A') e.preventDefault();
            fn(this);
        });
        $(document).on('change.samsungList', '[data-sl-change]', (e) => {
            const name = e.currentTarget.dataset.slChange;
            if (name === 'reserch' || name === 'onMonthChange') this[name]();
        });
        $(document).on('keyup.samsungList', '.js-skw', (e) => this.skw200check(e, e.currentTarget));
        // 폼 전송(엔터)은 막는다 — 검색은 reserch() 가 GET 으로 다시 연다
        $('#inputform').on('submit', (e) => e.preventDefault());
    }

    /** ESC — 펼쳐진 상세행을 닫는다. */
    initKeyHandler() {
        $(document).on('keydown.samsungList', (e) => {
            if (e.key !== 'Escape' && e.keyCode !== 27) return;
            if (!this.openedOrder) return;
            this.closeDetail();
        });
    }

    /** 행확장 상세(adm/pages/order/detail.blade.php)의 사진·전화번호 클릭 — 위임은 ListTable.bindDetail 이 건다 */
    exposeGlobals() {
        $j.F.Order.ListTable.bindDetail((ono, n) => this.showPic(ono, n));
    }

    initSelects() {
        // 지사/센터 코드는 세션 소속에서 나온다 — 서버가 스코프를 강제하므로 여기서 넓힐 수 없다.
        if (this.showGisaSelect) {
            Form.updateGisaSelectBox(this.sosok, 'y', 'z');
        } else if (this.showCenterSelect) {
            Form.updateCenterSelectBox(this.sosok, 'z');
        }
    }

    initDatePicker() {
        if ($j.Common.Util.isMobile()) return;
        $('#dserst,#dseren').mobiscroll().datepicker({
            controls: ['calendar'],
            dateFormat: 'YYYY-MM-DD',
            locale: mobiscroll.localeKo,
            buttons: [],
        });
    }

    /** 목록이 길어 상/하단 이동 버튼을 둔다. */
    initScrollArrow() {
        const $c = $('#samsung-list');
        $('#scrollArrow').on('click', () => {
            $c.animate({scrollTop: this.atBottom ? 0 : $c[0].scrollHeight}, 500);
            this.atBottom = !this.atBottom;
            $('#scrollArrow').text(this.atBottom ? '↑' : '↓');
        });
    }

    // ==================== 검색 ====================
    /** 현재 검색 UI 상태 → GET 파라미터로 재조회. */
    reserch() {
        const gisa = $('#y option:selected').val() || '';
        let center = $('#z option:selected').val() || '';
        // 고른 지사에 속하지 않는 센터는 버린다
        if (gisa && center.substring(0, 6) !== gisa) center = '';

        // #ym 은 input[type=month] → "YYYY-MM". 서버는 year/month 로 받는다.
        const [year, month] = ($('#ym').val() || '').split('-');

        const p = {
            year:      year || '',
            month:     month || '',
            serdatest: $('#dserst').val(),
            serdateen: $('#dseren').val(),
            fieldval:  $('#fieldval').val(),
            ordermemname: $('#ordermemname').val(),
            car_type:  $('#car_type option:selected').val() || '',
            y: gisa,
            z: center,
            unreviewed: $('#serunreviewed').attr('mysel') || '0',
        };
        for (let i = 1; i <= 5; i++) p['setty' + i] = $('#sertypesel' + i).attr('mysel');

        // PC 화면이라 location.href (뒤로가기로 이전 검색조건에 돌아갈 수 있어야 한다).
        // location.replace 규칙은 안드로이드 앱 웹뷰(/m/) 백버튼 대응용이다.
        location.href = '?' + $.param(p);
    }

    /** 검색조건 5버튼 토글. 배차됨/작업중/완료 중 하나라도 켜지면 '전체'는 꺼진다. */
    selchtype(tar) {
        $(tar).attr('mysel', $(tar).attr('mysel') === '1' ? '0' : '1');
        const anyOn = [2, 3, 4].some((i) => $('#sertypesel' + i).attr('mysel') === '1');
        if (anyOn) $('#sertypesel1').attr('mysel', '0');
        this.reserch();
    }

    /** 미확인(확인체크 안 된 오더) 필터 토글. 진행상태 토글과 겹쳐 걸린다. */
    selchUnreviewed(tar) {
        $(tar).attr('mysel', $(tar).attr('mysel') === '1' ? '0' : '1');
        this.reserch();
    }

    /** 검색월(input[type=month]) 변경 → 그 달로 조회. */
    onMonthChange() {
        if (!$('#ym').val()) return;
        this.searchByMonth();
    }

    /** 이달(0) / 전달(-1) */
    serRangeset(n) {
        const dt = new Date();
        // 1일로 먼저 옮긴다 — 31일에 setMonth(-1) 하면 '9월 31일' → 10월 1일로 넘쳐 이번 달에 머문다
        dt.setDate(1);
        if (n === -1) dt.setMonth(dt.getMonth() - 1);
        else if (n !== 0) return;

        $('#ym').val(dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0'));
        this.searchByMonth();
    }

    /** 검색월 기준 조회 — 날짜범위가 남아있으면 서버가 그쪽을 우선하므로 비운다. */
    searchByMonth() {
        $('#dserst,#dseren').val('');
        this.reserch();
    }

    /** 엔터=검색, 백스페이스로 비우면 재검색 */
    skw200check(evt, tar) {
        if (evt.keyCode === 13) this.reserch();
        else if (evt.keyCode === 8 && tar.value === '') this.reserch();
    }

    // ==================== 행 확장 ====================
    /** 오더 상세를 아래 행에 펼친다. 같은 행을 다시 누르면 접는다. */
    toggleDetail(orderNum) {
        const $tr = $('#eaTr_' + orderNum);
        const isOpen = $tr.is(':visible');

        this.closeDetail();
        if (isOpen) return;

        this.openedOrder = orderNum;
        // 이전에 열었던 상세가 남아있으면 다른 오더 내용이 잠깐 보이므로 자리표시로 되돌린다
        this.detailCell($tr).html('정보 불러오는 중');
        // 접힌 상태는 sass(.ea-tr)가 숨긴다 — show() 는 그런 tr 을 block 으로 띄우므로 table-row 를 직접 준다
        $tr.css('display', 'table-row');
        $.get('/p/ajax/order/detail', {ordernum: orderNum})
            .done((html) => this.detailCell($tr).html(html))
            .fail(() => this.detailCell($tr).html('<span style="color:red">정보를 불러올 수 없습니다.</span>'));
    }

    /** 펼쳐진 상세행 접기 (없으면 아무 일도 하지 않는다). */
    closeDetail() {
        $('#topTablein tbody tr[id^="eaTr_"]').hide();
        this.openedOrder = 0;
    }

    /**
     * 상세를 담는 칸.
     * find('td') 를 쓰면 한 번 불러온 뒤에는 상세 HTML 안의 중첩 td 까지 전부 잡혀
     * 다시 펼칠 때 셀마다 상세가 통째로 다시 박힌다 — 직계 td 만 골라야 한다.
     */
    detailCell($tr) {
        return $tr.children('td');
    }

    // ==================== 지도 / 사진 ====================
    showMap(pos1, pos2) {
        window.open(`/map/full?gps=${pos1},${pos2}`, 'mapshowwin',
            'toolbar=no,status=no,width=1000,height=900,directories=no,scrollbars=yes,location=no,resizable=yes,menubar=no');
    }

    /** 사진뷰어 창 (썸네일 클릭 / 상세의 사진 클릭) */
    showPic(orderno, n) {
        window.open(`/order/photos?ordernum=${orderno}&n=${n}`, 'photoPopupDetail',
            `toolbar=no,status=no,width=900,height=${window.screen.availHeight},directories=no,scrollbars=yes,location=no,resizable=yes,menubar=no`);
    }

    /** 오더번호 셀의 카메라 아이콘 → 썸네일 그리드를 셀 바로 아래에 띄운다. */
    showOrderPhoto(tar, num) {
        const $box = $('#photoListshow');
        if (num === this.shownPhoto && $box.is(':visible')) {
            $box.hide();
            return;
        }
        this.shownPhoto = num;

        const rect = tar.getBoundingClientRect();
        $.get('/p/ajax/orders/photos', {ordernum: num}, (html) => {
            $('#photoInsideList').html(html);
            $box.css('top', (rect.bottom + $(window).scrollTop()) + 'px').show();
        });
    }

    // ==================== 액션 ====================
    /**
     * 엑셀 저장 — 화면 테이블을 그대로 긁어 xls 로 내린다 (레거시 saveToExce_scsl).
     * .xls-skip 이 붙은 칸은 제외하고, .col-hide(삼성 제출양식 전용 빈칸)는 포함한다.
     * 월 단위 전량이 이미 화면에 있으므로 페이징 걱정이 없다.
     */
    saveToExcel() {
        let html = "<table border='2px'>";

        $('#topTablein tr[dataty="maintr"]').each(function () {
            // 확인완료 행의 연한 녹색은 클래스(.adonetr)로 들어가므로 인라인 style 이 아니라 계산값을 읽어야 한다
            const bg = getComputedStyle(this).backgroundColor;
            let tr = '';
            $(this).children('th,td').each(function () {
                if ($(this).hasClass('xls-skip')) return;
                if (this.nodeName === 'TH') {
                    tr += `<th>${this.innerHTML}</th>`;
                    return;
                }
                // 오더번호 칸은 아이콘/사진배지를 걷어내고 번호만 남긴다
                const raw = $(this).attr('repcont') === 'yes' ? $(this).attr('odno') : this.innerHTML;
                tr += `<td>${raw}</td>`;
            });
            html += `<tr style="background-color:${bg}">${tr}</tr>`;
        });
        html += '</table>';

        html = html.replace(/<a[^>]*>|<\/a>/gi, '')
                   .replace(/<img[^>]*>/gi, '')
                   .replace(/<input[^>]*>|<\/input>/gi, '');

        window.open('data:application/vnd.ms-excel,' + encodeURIComponent(html));
    }

    /** 신규발주 — 소속 기사를 고른 뒤 그 기사로 대리로그인해 모바일웹 발주화면으로 넘어간다. */
    newOrder() {
        window.open('/p/orders/new', 'svcNewOrder',
            'toolbar=no,status=no,width=700,height=800,directories=no,scrollbars=yes,location=no,resizable=yes,menubar=no');
    }

}
